var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrap",staticClass:"x-audio-wrap",class:{inline:!_vm.block},on:{"click":_vm.play}},[_c('div',{staticClass:"x-sector",class:{play:_vm.animate}},[_c('div',{staticClass:"x-dot"})]),_c('div',{staticClass:"x-time"},[_vm._v(_vm._s(_vm.duration&&_vm.showDuration?_vm.duration:_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }